import { render } from "./JoinCommunity.vue?vue&type=template&id=ba0f021a&scoped=true"
import script from "./JoinCommunity.vue?vue&type=script&lang=js"
export * from "./JoinCommunity.vue?vue&type=script&lang=js"

import "./JoinCommunity.vue?vue&type=style&index=0&id=ba0f021a&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba0f021a"]])

export default __exports__